import { gql } from 'gql/__generated__'

export const getAiConfigs = gql(`
  query getAiConfigs($filter: AiConfigFilter!) {
    data: aiConfigs(filter: $filter) {
      ...AiConfigSchema
    }
  }
`)
